/* Casa Pensierini — Advent calendar theme (IT) */
(function () {
  'use strict';
  var CPI = window.CPI || {};
  var R = CPI.routes || {};
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[CPI] ' + name, e); } }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function root() { return (R.root || '/').replace(/\/?$/, '/'); }
  function T(k, d) { return (CPI.t && CPI.t[k]) || d; }

  function money(cents) {
    var fmt = CPI.moneyFormat || '{{amount_with_comma_separator}} €';
    var v = (Number(cents) || 0) / 100;
    function f(n, d, ts, ds) {
      var p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return f(v, 2, ',', '.');
        case 'amount_no_decimals': return f(v, 0, ',', '.');
        case 'amount_with_comma_separator': return f(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(v, 2, "'", '.');
        default: return f(v, 2, ' ', ',');
      }
    });
  }

  function toast(msg) {
    var t = $('#cpiToast'); if (!t) return;
    t.innerHTML = '<span class="cpi-toast__ico">✦</span> ' + msg;
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  var SCOPED = [];
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Annonce ---------- */
  function init_announce(scope) {
    $$('[data-announce]', scope).forEach(function (bar) {
      var msgs = $$('.cpi-announce__msg', bar); if (msgs.length < 2) return;
      var i = 0, sp = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, sp);
    });
  }
  SCOPED.push(init_announce);
  safe('announce', function () { init_announce(document); });

  /* ---------- Header / recherche / menu ---------- */
  safe('header', function () {
    var h = $('[data-header]'); if (!h) return;
    var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 30); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var search = $('#cpiSearch');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]') && search) { search.hidden = !search.hidden; if (!search.hidden) { var i = $('input[type=search]', search); if (i) i.focus(); } }
      if (e.target.closest('[data-search-close]') && search) search.hidden = true;
    });

    var menu = $('#cpiMenu');
    function setMenu(on) { if (!menu) return; menu.classList.toggle('is-open', on); menu.setAttribute('aria-hidden', on ? 'false' : 'true'); lockScroll(on); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) setMenu(true);
      if (e.target.closest('[data-menu-close]')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setMenu(false); closeDrawer(); if (search) search.hidden = true; }
    });
  });

  /* ---------- Panier ---------- */
  var drawer = function () { return $('#cpiDrawer'); };
  function openDrawer() { var d = drawer(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lockScroll(true); }
  function closeDrawer() { var d = drawer(); if (!d || !d.classList.contains('is-open')) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lockScroll(false); }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    $$('.cpi-cartbtn').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
  }

  function refreshDrawer() {
    var d = drawer();
    return fetch(root() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!d || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('.cpi-drawer__panel', doc), cur = $('.cpi-drawer__panel', d);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        d.classList.remove('is-loading');
      })
      .then(function () { return fetch(root() + 'cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); });
  }

  safe('cart', function () {
    document.addEventListener('submit', function (e) {
            var form = e.target.closest('form[data-cpi-add]'); if (!form) return;
      if ((CPI.cartType || 'drawer') === 'redirect' && !DESIGN) return;
      e.preventDefault();
      var btn = $('[type=submit]', form); if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
      fetch(root() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          var type = CPI.cartType || 'drawer';
          if (type === 'redirect' && !DESIGN) { window.location.href = R.cart || '/cart'; return; }
          if (type === 'drawer' && drawer()) { return refreshDrawer().then(openDrawer); }
          return fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); toast(T('added', 'Aggiunto al carrello!')); });
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || (CPI.t && CPI.t.error)); })
        .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && drawer()) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var ch = e.target.closest('[data-qty-change]');
      if (ch) {
        var d = drawer(); if (d) d.classList.add('is-loading');
        fetch(root() + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(ch.getAttribute('data-qty-change'), 10), quantity: parseInt(ch.getAttribute('data-qty'), 10) })
        }).then(refreshDrawer).catch(function () { if (d) d.classList.remove('is-loading'); toast(CPI.t && CPI.t.error); });
      }
    });

    var saveNote = debounce(function (v) {
      fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
    }, 600);
    document.addEventListener('input', function (e) { if (e.target.matches('[data-cart-note]')) saveNote(e.target.value); });
  });

  /* ---------- Quantités ---------- */
  safe('qty', function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]'); if (!b) return;
      var input = $('input', b.closest('.cpi-qty')); if (!input) return;
      var min = parseInt(input.min || '1', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var submitCart = debounce(function (form) { form.submit(); }, 700);
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-autosubmit]')) { var f = e.target.closest('form'); if (f) submitCart(f); }
    });
  });

  /* ---------- Fiche produit ---------- */
  function init_product(scope) {
    $$('[data-product]', scope).forEach(function (sec) {
      var jsonEl = $('[data-product-json]', sec); if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var idInput = $('[data-variant-id]', sec);
      var atc = $('[data-atc]', sec), atcLabel = $('[data-atc-label]', sec);
      var atcDefault = atcLabel ? atcLabel.textContent : T('addToCart', 'Aggiungi al carrello');
      if (atc && atc.disabled === false) atcDefault = atcLabel.textContent;
      var picker = $('[data-variant-picker]', sec);

      function current() {
        var vals = [];
        $$('fieldset', picker).forEach(function (fs, i) { var c = $('input:checked', fs); vals[i] = c ? c.value : null; });
        return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
      }

      function render(v) {
        if (!v) {
          if (atc) atc.disabled = true;
          if (atcLabel) atcLabel.textContent = T('unavailable', 'Non disponibile');
          return;
        }
        if (idInput) idInput.value = v.id;
        $$('[data-price-wrap]', sec).forEach(function (w) {
          var p = $('[data-price]', w), c = $('[data-compare]', w), s = $('[data-savings]', w);
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          if (p) p.textContent = money(v.price);
          if (c) { c.hidden = !sale; c.textContent = sale ? money(v.compare_at_price) : ''; }
          if (s) { s.hidden = !sale; var st = $('strong', s); if (st) st.textContent = sale ? money(v.compare_at_price - v.price) : ''; }
          w.classList.toggle('cpi-price--sale', !!sale);
        });
        var pct = $('[data-pct]', sec);
        if (pct) {
          var sale2 = v.compare_at_price && v.compare_at_price > v.price;
          pct.hidden = !sale2;
          if (sale2) pct.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %';
        }
        if (atc) { atc.disabled = !v.available; }
        if (atcLabel) atcLabel.textContent = v.available ? atcDefault : (T('soldOut', 'Esaurito'));
        var sticky = $('[data-sticky-go]', sec); if (sticky) { sticky.disabled = !v.available; }
        var stock = $('[data-stock]', sec);
        if (stock) {
          var txt = $('[data-stock-text]', stock);
          stock.classList.toggle('cpi-stock--out', !v.available);
          stock.classList.remove('cpi-stock--low');
          if (!v.available) txt.textContent = T('soldOut', 'Esaurito');
          else txt.textContent = T('inStock', 'Disponibile · spedito in 24 h');
        }
        $$('[data-opt-label]', sec).forEach(function (l) { var i = +l.getAttribute('data-opt-label'); l.textContent = v.options[i]; });
        if (v.featured_media) goToMedia(v.featured_media.id);
        if (!DESIGN && window.history && window.history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
        }
      }
      if (picker) picker.addEventListener('change', function () { render(current()); });

      /* galerie */
      var track = $('[data-gallery-track]', sec);
      var thumbs = $$('[data-thumb]', sec);
      var dots = $$('.cpi-gallery__dots span', sec);
      function setActive(i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); });
        dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
      }
      function goTo(i) { if (!track) return; track.scrollTo({ left: track.clientWidth * i, behavior: REDUCED ? 'auto' : 'smooth' }); setActive(i); }
      function goToMedia(id) {
        if (!track) return;
        var slides = $$('.cpi-gallery__slide', track);
        for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(id)) { goTo(i); return; }
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-thumb')); }); });
      if (track) track.addEventListener('scroll', debounce(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 80), { passive: true });

      /* barre collante */
      var bar = $('[data-sticky-atc]', sec);
      if (bar && atc && 'IntersectionObserver' in window) {
        bar.hidden = false;
        new IntersectionObserver(function (en) {
          var e = en[0];
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0 && window.innerWidth < 990);
        }).observe(atc);
        var go = $('[data-sticky-go]', bar);
        if (go) go.addEventListener('click', function () { atc.click(); });
      }
    });
  }
  SCOPED.push(init_product);
  safe('product', function () { init_product(document); });

  /* ---------- Estimation de livraison ---------- */
  function init_eta(scope) {
    $$('[data-eta]', scope).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 4;
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var now = new Date();
      var parisH = now.getHours();
      try { parisH = parseInt(new Intl.DateTimeFormat('it-IT', { hour: 'numeric', hour12: false, timeZone: 'Europe/Paris' }).format(now), 10); } catch (e) {}
      var ship = new Date(now);
      function isWeekend(d) { return d.getDay() === 0 || d.getDay() === 6; }
      if (parisH >= cutoff || isWeekend(ship)) { do { ship.setDate(ship.getDate() + 1); } while (isWeekend(ship)); }
      function addBiz(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (!isWeekend(r)) n--; } return r; }
      var a = addBiz(ship, min), b = addBiz(ship, max);
      var f = function (d) { return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'long' }); };
      var out = $('[data-eta-range]', el); if (out) out.textContent = T('etaBetween', 'tra') + ' ' + f(a) + ' ' + T('etaAnd', 'e') + ' ' + f(b);
    });
  }
  SCOPED.push(init_eta);
  safe('eta', function () { init_eta(document); });

  /* ---------- Compte à rebours ---------- */
  function init_countdown(scope) {
    $$('[data-countdown]', scope).forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var D = $('[data-d]', el), H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { el.classList.add('is-done'); el.textContent = el.getAttribute('data-done') || ''; clearInterval(iv); return; }
        var s = Math.floor(diff / 1000);
        D.textContent = pad(Math.floor(s / 86400)); H.textContent = pad(Math.floor(s % 86400 / 3600));
        M.textContent = pad(Math.floor(s % 3600 / 60)); S.textContent = pad(s % 60);
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }
  SCOPED.push(init_countdown);
  safe('countdown', function () { init_countdown(document); });

  /* ---------- Calendrier 24 cases ---------- */
  function init_advent(scope) {
    $$('[data-advent]', scope).forEach(function (sec) {
      var year = parseInt(sec.getAttribute('data-year'), 10) || new Date().getFullYear();
      var demo = sec.getAttribute('data-demo') === '1';
      var locked = sec.getAttribute('data-locked') || T('locked', 'Ancora un po\' di pazienza… questa casella si aprirà il');
      var key = 'cpiAdvent' + year;
      var opened = []; try { opened = JSON.parse(store(key) || '[]'); } catch (e) { opened = []; }
      var now = new Date();
      var dec = now.getFullYear() === year && now.getMonth() === 11;
      var after = now.getFullYear() > year;
      var today = dec ? now.getDate() : (after ? 31 : 0);
      var modal = $('[data-door-modal]', sec), body = $('[data-modal-body]', sec);

      function canOpen(day) { return demo || day <= today; }
      $$('.cpi-door', sec).forEach(function (door) {
        var day = +door.getAttribute('data-day');
        if (dec && day === today) door.classList.add('is-today');
        if (opened.indexOf(day) > -1 && canOpen(day)) door.classList.add('is-open');
        $('[data-door]', door).addEventListener('click', function () {
          if (!canOpen(day)) {
            door.classList.remove('is-locked'); void door.offsetWidth; door.classList.add('is-locked');
            toast(locked + ' ' + day + ' ' + T('december', 'dicembre'));
            return;
          }
          door.classList.add('is-open');
          if (opened.indexOf(day) < 0) { opened.push(day); store(key, JSON.stringify(opened)); }
          var tpl = $('template[data-door-content]', door);
          setTimeout(function () {
            if (!modal || !tpl) return;
            body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
            modal.hidden = false; lockScroll(true);
            burst(door);
          }, REDUCED ? 0 : 520);
        });
      });
      if (modal) modal.addEventListener('click', function (e) { if (e.target.closest('[data-modal-close]')) { modal.hidden = true; lockScroll(false); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) { modal.hidden = true; lockScroll(false); } });
    });
  }
  SCOPED.push(init_advent);
  safe('advent', function () { init_advent(document); });

  function burst(el) {
    if (REDUCED || !el) return;
    var r = el.getBoundingClientRect();
    var cs = window.getComputedStyle(document.documentElement);
    var BURST = [(cs.getPropertyValue('--cpi-gold') || '#D49A78').trim(), (cs.getPropertyValue('--cpi-primary') || '#8C2F5D').trim()];
    for (var i = 0; i < 18; i++) {
      var s = document.createElement('span');
      s.textContent = i % 3 ? '✦' : '❄';
      s.style.cssText = 'position:fixed;z-index:350;pointer-events:none;font-size:' + (10 + Math.random() * 12) + 'px;color:' + (i % 2 ? BURST[0] : BURST[1]) + ';left:' + (r.left + r.width / 2) + 'px;top:' + (r.top + r.height / 2) + 'px;transition:transform 1s cubic-bezier(.2,.8,.2,1),opacity 1s;';
      document.body.appendChild(s);
      (function (s) {
        var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 90;
        requestAnimationFrame(function () { s.style.transform = 'translate(' + Math.cos(a) * d + 'px,' + Math.sin(a) * d + 'px) rotate(' + (Math.random() * 360) + 'deg)'; s.style.opacity = '0'; });
        setTimeout(function () { s.remove(); }, 1100);
      })(s);
    }
  }

  /* ---------- Copier (codes, liens) ---------- */
  safe('copy', function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy]'); if (!b) return;
      var v = b.getAttribute('data-copy');
      var done = function () { toast(T('copied', 'Copiato:') + ' ' + v); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, done);
      else { var t = document.createElement('textarea'); t.value = v; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (er) {} t.remove(); done(); }
    });
  });

  /* ---------- Collection : tri & filtres ---------- */
  safe('collection', function () {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var f = $('#cpiFilters');
    document.addEventListener('click', function (e) {
      if (!f) return;
      if (e.target.closest('[data-filters-open]')) { f.classList.add('is-open'); f.setAttribute('aria-hidden', 'false'); lockScroll(true); }
      if (e.target.closest('[data-filters-close]')) { f.classList.remove('is-open'); f.setAttribute('aria-hidden', 'true'); lockScroll(false); }
    });
  });

  /* ---------- Recommandations ---------- */
  safe('related', function () {
    $$('[data-related]').forEach(function (el) {
      if (el.children.length) return;
      var url = el.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-related]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.remove();
      }).catch(function () { el.remove(); });
    });
  });

  /* ---------- Suivi de colis ---------- */
  safe('tracking', function () {
    $$('[data-track]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = ($('input', f).value || '').replace(/\s+/g, '').toUpperCase(); if (!n) return;
        window.open((CPI.trackUrl || 'https://t.17track.net/fr#nums=') + encodeURIComponent(n), '_blank', 'noopener');
      });
    });
  });

  /* ---------- Sommaire pages légales ---------- */
  safe('toc', function () {
    var toc = $('[data-toc]'), body = $('[data-legal-body]'); if (!toc || !body) return;
    var hs = $$('h2', body);
    if (!hs.length) { toc.previousElementSibling && toc.previousElementSibling.remove(); toc.remove(); return; }
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; toc.appendChild(a);
    });
    if ('IntersectionObserver' in window) {
      var links = $$('a', toc);
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + e.target.id); }); });
      }, { rootMargin: '-20% 0px -70% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    }
  });

  /* ---------- Compte : mot de passe oublié ---------- */
  safe('auth', function () {
    var w = $('[data-auth]'); if (!w) return;
    var l = $('[data-auth-login]', w), r = $('[data-auth-recover]', w);
    if (window.location.hash === '#recover') { l.hidden = true; r.hidden = false; }
    w.addEventListener('click', function (e) { if (e.target.closest('[data-auth-toggle]')) { l.hidden = !l.hidden; r.hidden = !r.hidden; } });
  });

  /* ---------- Apparition au défilement ---------- */
  safe('reveal', function () {
    if (DESIGN || REDUCED || !('IntersectionObserver' in window)) return;
    var els = $$('.cpi-head, .cpi-card, .cpi-cat, .cpi-trust__item, .cpi-review, .cpi-rank__item, .cpi-story__grid > *, .cpi-promo__box');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
    var cs = window.getComputedStyle(document.documentElement);
    var BURST = [(cs.getPropertyValue('--cpi-gold') || '#D49A78').trim(), (cs.getPropertyValue('--cpi-primary') || '#8C2F5D').trim()];
      if (r.top < window.innerHeight) return;
      el.classList.add('cpi-reveal');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  });

  /* ---------- Neige ---------- */
  safe('snow', function () {
    var c = $('#cpiSnow'); if (!c || !CPI.snow || REDUCED) { if (c) c.remove(); return; }
    if (!CPI.snowMobile && window.innerWidth < 750) { c.remove(); return; }
    var ctx = c.getContext('2d'), W, H, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var n = parseInt(CPI.snowCount, 10) || 50, flakes = [];
    function size() { W = window.innerWidth; H = window.innerHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', debounce(size, 200));
    var cols = ['255,255,255', '230,236,245', '212,154,120', '255,255,255', '200,214,235'];
    for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: .8 + Math.random() * 2.6, s: .25 + Math.random() * .8, w: Math.random() * 6.28, o: .35 + Math.random() * .55, c: cols[i % cols.length], star: Math.random() < .22 });
    var running = true;
    document.addEventListener('visibilitychange', function () { running = !document.hidden; if (running) loop(); });
    /* petite étoile à 6 branches */
    function star(x, y, r) {
      var L = r * 3; ctx.save(); ctx.strokeStyle = ctx.fillStyle; ctx.lineWidth = Math.max(.8, r * .45); ctx.lineCap = 'round'; ctx.beginPath();
      for (var k = 0; k < 6; k++) { var a = k * Math.PI / 3; ctx.moveTo(x, y); ctx.lineTo(x + Math.cos(a) * L, y + Math.sin(a) * L); }
      ctx.stroke(); ctx.restore();
    }
    function loop() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.s; f.w += .012; f.x += Math.sin(f.w) * .35;
        if (f.y > H + 10) { f.y = -10; f.x = Math.random() * W; }
        ctx.fillStyle = 'rgba(' + f.c + ',' + (f.star ? (.4 + Math.abs(Math.sin(f.w * 3)) * .6) : f.o) + ')';
        if (f.star) star(f.x, f.y, f.r * .9);
        else { ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill(); }
      }
      requestAnimationFrame(loop);
    }
    loop();
  });

  /* Éditeur de thème : réinitialise les sections rechargées */
  if (DESIGN) {
    document.addEventListener('shopify:section:load', function (e) {
      SCOPED.forEach(function (fn) { safe('reload', function () { fn(e.target); }); });
    });
  }
})();
